import styled from 'styled-components';

export const ColunaInformacoes = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.spacing[5]}px;
`;

export const ColunaLinks = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing[3]}px 0;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const LinhaImagens = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: ${({ theme }) => theme.spacing[6]}px;
`;

export const ColunaAplicativos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing[5]}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ColunaLogos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;
